module.exports = __webpack_public_path__ + "static/media/screenshot11.0b071316.png";